import { defineComponent as _defineComponent } from 'vue'
import type { WebLocale } from '@/enums/web-locale';

import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'CountryListItem',
  props: {
    webLocale: null,
    selected: { type: Boolean, default: false },
    excluded: { type: Boolean, default: false }
  },
  setup(__props: any) {

const props = __props as { webLocale: WebLocale, selected: boolean, excluded: boolean };



const classNames = computed(() => {
	return {
		'country-list-item': true,
		'country-list-item--selected': props.selected,
		'country-list-item--excluded': props.excluded,
	};
});

const icon = computed(() => {
	if (props.excluded) {
		return 'minus-circle';
	}

	if (props.selected) {
		return 'jw-check-icon';
	}
});

const src = computed(() => `${JW_CONFIG.ASSETS_URL}/flags/${props.webLocale.toUpperCase()}.png`);

return { __sfc: true,props, classNames, icon, src }
}

})